<template>
    <Modal v-if="showModal" @closeClicked="hideModal">
        <template v-slot:header>
            <h1>Add portfolio</h1>
        </template>

        <template v-slot:body>
            <p v-if="error" class="text-red">{{ error }}</p>
            <input type="text" placeholder="My portfolio" v-model="name">
            <input type="text" placeholder="https://docs.google.com/spreadsheets/d/..." v-model="spreadsheetUrl">
            Tab/sheet name: <input type="text" v-model="spreadsheetTab">
        </template>

        <template v-slot:footer>
            <div class="buttons text-right">
                <div class="button" @click="hideModal">Cancel</div>
                <div class="button green" @click="addPortfolio">Add</div>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from '@/components/global/Modal'

export default {
    components: { Modal },
    props:{
        showModal: Boolean, // showModal.sync
    },
    data(){
        return{
            name: '',
            spreadsheetTab: '',
            spreadsheetUrl: '',
            error: '',
        }
    },
    computed:{
        spreadsheetKey(){
            if(this.spreadsheetUrl.includes('docs.google.com/spreadsheets/d/')){
                // get ID from https://docs.google.com/spreadsheets/d/<ID>/edit
                const id = this.spreadsheetUrl.split('docs.google.com/spreadsheets/d/')[1].split('/')[0]
                return id
            }
            return null
        }
    },
    methods:{
        hideModal(){
            this.name = ''
            this.spreadsheetUrl = ''
            this.error = ''
            this.$emit('update:showModal', false)
        },
        addPortfolio(){
            const portfolios = JSON.parse(localStorage.getItem('portfolios') || '[]')

            if(this.name.trim() == ''){
                this.error = 'Name cannot be empty'
                return
            }
            if(this.spreadsheetKey == null){
                this.error = 'Please enter a valid spreadsheet url'
                return
            }
            if(this.spreadsheetTab.trim() == ''){
                this.error = 'Please enter the tab/sheet name'
                return
            }
            for(const pf of portfolios){
                if(pf.name.trim() == this.name){
                    this.error = 'A portfolio with this name already exists'
                    return
                }
                const spreadsheetTab = pf.spreadsheetTab || 1;
                if(pf.spreadsheetKey == this.spreadsheetKey && spreadsheetTab == this.spreadsheetTab){
                    this.error = `A portfolio for this spreadsheet already exists. (${pf.name})`
                    return
                }
            }

            portfolios.push({
                name: this.name,
                spreadsheetKey: this.spreadsheetKey,
                spreadsheetTab: this.spreadsheetTab,
            })
            localStorage.setItem('portfolios', JSON.stringify(portfolios))
            this.hideModal()
            this.$emit('portfolioAdded')
        }
    }
}
</script>